import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Forge & Flow nav transition overlay.
 *
 * Click flow:
 *   1. Dark panel sweeps in left→right  (0–260ms)
 *   2. Orange panel sweeps in  (+40ms delay, 0–240ms)
 *   3. Section label flashes in centre  (~180ms)
 *   4. Page has already hard-jumped to target section (280ms mark in App.js)
 *   5. active → false: both panels sweep OUT right→left simultaneously
 */

const springIn  = { duration: 0.26, ease: [0.76, 0, 0.24, 1] };
const springOut = { duration: 0.28, ease: [0.76, 0, 0.24, 1] };

const Panel = ({ bg, delayIn = 0, delayOut = 0 }) => (
  <motion.div
    className={`absolute inset-0 ${bg}`}
    initial={{ scaleX: 0, originX: 0 }}
    animate={{ scaleX: 1, originX: 0, transition: { ...springIn, delay: delayIn } }}
    exit={{
      scaleX: 0,
      originX: 1,
      transition: { ...springOut, delay: delayOut },
    }}
  />
);

const NavTransition = ({ active, label }) => (
  <AnimatePresence>
    {active && (
      <div
        className="fixed inset-0 pointer-events-none overflow-hidden"
        style={{ zIndex: 9999 }}
      >
        {/* Panel 1 — dark, leads the wipe */}
        <Panel bg="bg-gray-950" delayIn={0} delayOut={0.04} />

        {/* Panel 2 — orange, half-beat behind */}
        <Panel bg="bg-orange-500" delayIn={0.05} delayOut={0} />

        {/* Section label — appears in the centre while panels are fully in */}
        <motion.div
          className="absolute inset-0 flex items-center justify-center"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0, transition: { delay: 0.18, duration: 0.12 } }}
          exit={{ opacity: 0, y: -8, transition: { duration: 0.1 } }}
        >
          <span className="text-white font-black uppercase tracking-[0.3em] text-xl md:text-3xl select-none">
            {label}
          </span>
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);

export default NavTransition;
